<template>
    <div>
        <MapDetails v-if="['map', 'add-map'].indexOf($route.name) !== -1" />
    </div>
</template>

<script>
import BackButton from 'common/BackButton';
import MapDetails from 'maps/MapDetails';

export default {
  components: {
    BackButton,
    MapDetails,
  },
  data() {
    return {
    };
  },
  route: {
    canReuse: true,
    isDetailDeleted: false,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/maps/MainView.vue